
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"m14.895 11.042-2.23.892a.86.86 0 0 0-.48.48l-.893 2.231a.853.853 0 0 1-1.584 0l-.892-2.23a.86.86 0 0 0-.48-.48l-2.231-.893a.854.854 0 0 1 0-1.584l2.23-.892a.86.86 0 0 0 .48-.48l.893-2.231a.853.853 0 0 1 1.584 0l.892 2.23a.86.86 0 0 0 .48.48l2.231.893a.853.853 0 0 1 0 1.584ZM5.925 3.35l-.478-.956a.5.5 0 0 0-.894 0l-.478.957a.5.5 0 0 1-.224.224l-.957.478a.5.5 0 0 0 0 .894l.957.478a.5.5 0 0 1 .224.224l.478.957a.5.5 0 0 0 .894 0l.478-.957a.5.5 0 0 1 .224-.224l.957-.478a.5.5 0 0 0 0-.894l-.957-.478a.5.5 0 0 1-.224-.224Z","stroke":"#798F8F"}})])
          )
        }
      }
    